import apiService from '@/state/services/Api'
import deviceMock from '@/state/mock/devices.json'

const devices = {
  namespaced: true,
  state: {
    moduleTypes: {},
    meterTypes: {},
  },
  getters: {
    moduleTypes(state) {
      let modTypes = []
      for (const key in state.moduleTypes) {
        if (state.moduleTypes.hasOwnProperty(key)) {
          modTypes.push({label: state.moduleTypes[key], value: key})
        }
      }
      return modTypes
    },

    meterTypes(state) {
      let types = []
      for (const key in state.meterTypes) {
        if (state.meterTypes.hasOwnProperty(key)) {
          types.push({label: state.meterTypes[key], value: key})
        }
      }
      return types
    },
  },
  mutations: {
    SET_DEVICE_TYPES(state, payload) {
      state.moduleTypes = payload.communication_module_types
      state.meterTypes = payload.meter_types
    },
  },
  actions: {
    postSwisscom({state, commit, rootState}, devices) {
      return apiService.post(`devices/swisscom_lpn/`, {devices, action: 'register'}).then(data => {
        return data
      })
    },

    deleteSwisscom({state, commit, rootState}, devices) {
      return apiService.post(`devices/swisscom_lpn/`, {devices, action: 'delete'}).then(data => {
        return data
      })
    },

    getTaskSwisscom({state, commit}, id) {
      return apiService
        .get(`devices/swisscom_lpn_result/`, {
          params: {
            task_id: id,
          },
        })
        .then(data => {
          return data
        })
    },

    getTypes({state, commit, rootState}) {
      return apiService
        .fetch(`devices/types/`)
        .then(data => {
          commit('SET_DEVICE_TYPES', data)
          return data
        })
        .catch(err => {
          console.warn(err)
        })
    },

    create({state, commit}, payload) {
      return apiService.post(`devices/`, payload).then(data => {
        return data
      })
    },

    update({state, commit}, {comm_mod_uuid, body}) {
      return apiService.patch(`keys/${comm_mod_uuid}/`, body).then(data => {
        return data
      })
    },

    getAfm({state, commit, getters}) {
      const modId = getters['meterTypes'].filter(type => type.label === 'AFM')[0]
      return apiService.get(`meters/?meter_type=${modId.value}&limit=9999`).then(data => {
        return data
      })
    },

    delete({state, commit}, {comm_mod_uuid}) {
      return apiService.patch(`keys/${comm_mod_uuid}/`, {is_deleted: true}).then(data => {
        return data
      })
    },

    async getDevices(context, params = {}) {
      try {
        return Object.keys(params).length
          ? await apiService.get(`installations/`, {params})
          : await apiService.query(`installations/`)
      } catch (error) {
        return error
      }
    },

    async getDevice(context, uuid) {
      if (!uuid) {
        return
      }
      try {
        return await apiService.get(`installations/${uuid}`)
      } catch (error) {
        return Promise.reject(error)
      }
    },

    getGeolocationTemplate({state, commit, rootState}, devices) {
      return apiService.get(`get-template/`).then(data => {
        return data
      })
    },

    async updateGeolocation(context, file) {
      const payload = new FormData()
      payload.append('file', file)
      return apiService.post('update-geopositions', payload).then(data => {
        return data?.split(':').slice(-1)[0]?.trim()
      })
    },
  },
}

export default devices
